import domReady from '@wordpress/dom-ready';

domReady(() => {
  const selectWrapper = document.querySelector('#selectWrapper');
  const anchorSelect = selectWrapper.querySelector('#anchorSelect');
  const selectPopup = selectWrapper.querySelector('#selectPopup');
  const fakeOverlay = document.querySelector('#fakeOverlay');

  if (selectWrapper) {
    anchorSelect.addEventListener('click', () => {
      selectPopup.classList.toggle('active');

      if (selectPopup.classList.contains('active')) {
        selectPopup.setAttribute('aria-hidden', false);
        anchorSelect.setAttribute('aria-expanded', true);
      } else {
        selectPopup.setAttribute('aria-hidden', true);
        anchorSelect.setAttribute('aria-expanded', false);
      }

      fakeOverlay.classList.toggle('active');
    });

    document.addEventListener('scroll', () => {
      selectPopup.classList.remove('active');
      selectPopup.setAttribute('aria-hidden', true);
      anchorSelect.setAttribute('aria-expanded', false);
      fakeOverlay.classList.remove('active');
    });

    fakeOverlay.addEventListener('click', () => {
      selectPopup.classList.remove('active');
      selectPopup.setAttribute('aria-hidden', true);
      anchorSelect.setAttribute('aria-expanded', false);
      fakeOverlay.classList.remove('active');
    });
  }
});
